import { render, staticRenderFns } from "./CallsList.vue?vue&type=template&id=6acee042&scoped=true&"
import script from "./CallsList.vue?vue&type=script&lang=js&"
export * from "./CallsList.vue?vue&type=script&lang=js&"
import style0 from "./CallsList.vue?vue&type=style&index=0&id=6acee042&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acee042",
  null
  
)

export default component.exports